/**
 * Sync job status sets (SCH-2681, KTD16).
 *
 * The two questions every reader of `PlatformDataSyncJob.status` asks, answered
 * once: has the job stopped (terminal), and did it stop without failing
 * (non-failure terminal). `pnpm sj`, the web badges and the platform-sync skill
 * import these instead of keeping their own lists.
 *
 * Kept equal to the backend's sets in `apps/backend/src/types/sync-enums.ts`
 * (`TERMINAL_SYNC_JOB_STATUSES`, `NON_FAILURE_TERMINAL_SYNC_JOB_STATUSES`) by
 * `apps/backend/tests/services/platform-data-sync/catalog/shared-types-parity.test.ts`.
 *
 * `PARTIAL_SUCCESS` is in both: some items failed, the run as a whole did its
 * job, and rollup already counts it as a success (learnings C9). Typed as plain
 * strings, like `syncType`, so a reader can test any column value without a cast.
 */

/** A job in one of these has stopped and will not run again. A poll loop stops on all of them. */
export const TERMINAL_SYNC_JOB_STATUSES: readonly string[] = [
  'SUCCESS',
  'PARTIAL_SUCCESS',
  'FAILED',
  'CANCELLED',
  'ABANDONED',
  'SKIPPED_TOKEN_ABSENT',
  'SKIPPED_COVERED',
  'SKIPPED_NOT_BUILT'
]

/**
 * Terminal statuses that are not failures. The skips did no Blackbaud work on
 * purpose (dead token, covered by a peer, handler not built yet) and advance
 * `lastAttemptedSync` without touching a failure counter.
 */
export const NON_FAILURE_TERMINAL_SYNC_JOB_STATUSES: readonly string[] = [
  'SUCCESS',
  'PARTIAL_SUCCESS',
  'SKIPPED_TOKEN_ABSENT',
  'SKIPPED_COVERED',
  'SKIPPED_NOT_BUILT'
]
